import { getTemplate } from "../template-helper";
import Mustache from "mustache";
import { uuidv4 } from "../../util/utils";


const COMPONENT_NAME = "z-checkbox-list" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class CheckboxListComponent extends HTMLElement {
            constructor() {
                super();
                this.innerHTML = "" ;
                this.currentValue = null ;
            }

            connectedCallback(){
                this.currentValue = null ;
                this.init() ;
            }


            initMarkup(){
                if(this.initDone){ 
                    return  ; 
                }
                this.initDone = true ;
                const clone = document.importNode(template.content, true);
                this.appendChild(clone);

            }
            init(){
                this.initMarkup() ;
                this.container = this.querySelector(".z-checkbox-list-container") ;
                this.input = this.querySelector(".z-checkbox-list-input") ;
                this.labelFields = (this.getAttribute("z-label-fields")||"").split(",").map(f=>f.trim()).filter(f=>!!f) ;
                this.fieldId = (this.getAttribute("z-field-id")||"_id") ;
                this.name = this.getAttribute("name") || uuidv4();
                

                this.currentValue = this.getAttribute("value") ;
                if(this.currentValue && this.currentValue[0]==="["){
                    try{
                        this.currentValue = JSON.parse(this.currentValue) ;
                    }catch(err){
                        console.log("WRONG checkbox values", this.currentValue) ;
                        this.currentValue = null;
                    }
                }else{
                    this.currentValue = null;
                }


                this.applyReadOnly() ;
                this.applyRequired() ;
                this.applyOptions() ;
            }

            applyOptions(){
                if(!this.container){ return ; }
                
                const strOptions = this.getAttribute("z-options") ;
                let objOptions = null;
                try{
                    objOptions = JSON.parse(strOptions) ;
                }catch(err){
                    objOptions = [] ;
                }
                this.container.innerHTML = "" ;
                let valueFound = false;
                for(let obj of objOptions){
                    const div = document.createElement("DIV") ;
                    const mappedObj = this.mapValue(obj) ;
                    div.innerHTML = `<div class="form-check">
                    <input class="form-check-input" type="checkbox" name="${this.name}" 
                        id="${this.name}_${mappedObj.id}" value="${mappedObj.id}" ${(this.currentValue&&this.currentValue.includes(mappedObj.id))?"checked":""}>
                        <label class="form-check-label" for="${this.name}_${mappedObj.id}">
                            ${mappedObj.label}
                        </label>
                    </div>` ;
                    this.container.appendChild(div) ;
                    div.querySelector("input").addEventListener("change", ()=>{
                        const checkboxs = Array.prototype.slice.apply(this.container.querySelectorAll(".form-check-input")) ;
                        this.currentValue = checkboxs.filter(checkbox=>checkbox.checked).map(checkbox=>checkbox.value) ;
                        this.input.value = this.currentValue.join();
                        this.dispatchEvent(new Event('change', {bubbles: true}));
                    }) ;
                    if(this.currentValue && this.currentValue.includes(mappedObj.id)){
                        valueFound = true;
                    }
                }
                if(!valueFound){
                    this.currentValue = "" ;
                    this.input.value = "" ;
                }
            }

            get value() {
                return this.currentValue ;
            }
            
            set value(value) {
                if(!value){
                    value = [] ;
                }else if(typeof(value)==="string"){
                    if(value[0]==="["){
                        try{
                            value = JSON.parse(value) ;
                        }catch(err){
                            console.error("WRONG ARRAY VALUE "+value) ;
                            value = [] ;
                        }
                    }else{
                        value = value.split(",") ;
                    }
                }
                this.currentValue = value;
                this.input.value = value.join(",") ;
                const checkboxs = Array.prototype.slice.apply(this.container.querySelectorAll(".form-check-input")) ;
                for(let checkbox of checkboxs){
                    checkbox.checked = value.includes(checkbox.value) ;
                }
            }

            get required() {
                return this.input.hasAttribute("required") ;
            }
            
            set required(required) {
                this.input.setAttribute('required', required);
            }
            
            static get observedAttributes() {
                return ['value', 'readonly', "required", "z-options"];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                let value = newValue;
                switch (name) {
                    case 'value':
                        if(!value){
                            value = [] ;
                        }else if(typeof(value)==="string"){
                            if(value[0]==="["){
                                try{
                                    value = JSON.parse(value) ;
                                }catch(err){
                                    console.error("WRONG ARRAY VALUE "+value) ;
                                    value = [] ;
                                }
                            }else{
                                value = value.split(",") ;
                            }
                        }
                        this.value = value ;
                    break;
                    case 'required':
                        this.applyRequired();
                        break;
                    case 'readonly':
                        this.applyReadOnly() ;
                        break;
                    case 'z-options':
                        this.applyOptions() ;
                        break;
                }
            }

            applyReadOnly(){
                if(!this.input){ return ; }
                const checkboxs = Array.prototype.slice.apply(this.container.querySelectorAll(".form-check-input")) ;
                if(this.hasAttribute("readonly")){
                    for(let checkbox of checkboxs){
                        checkbox.disabled = true ;
                    }
                }else{
                    for(let checkbox of checkboxs){
                        checkbox.disabled = false ;
                    }
                }
            }

            mapValue(r){
                if(!r){
                    return {
                        id: null,
                        label: ""
                    } ;
                }
                
                var labelField = this.labelFields.map(function(f){ 
                    if(f.includes("{{")){ return f; }
                    return "{{"+f+"}}" ;
                }).join(" - ") ;
                Mustache.parse(labelField);
                var label = Mustache.render(labelField, r); 
                return {
                    id: r[this.fieldId||"id"],
                    label: label 
                } ;
            }
            
            applyRequired(){
                const required = this.hasAttribute("required") ;
                if(this.input){
                    if(required){
                        this.input.setAttribute("required", "required") ;
                    }else{
                        this.input.removeAttribute("required") ;
                    }
                }
            }
        }
        customElements.define(COMPONENT_NAME, CheckboxListComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
